import React from 'react';
import { Link } from 'react-router-dom';

export default function Cookies() {
  return (
    <div className="max-w-4xl mx-auto px-6 py-12 text-gray-800">
      <Link to="/" className="text-cyan-500 underline mb-6 inline-block">← Back to Home</Link>
      <h1 className="text-3xl font-bold mb-4">Cookies Policy</h1>
      <p className="mb-4">
        We use cookies to improve your browsing experience. By using our site, you agree to our use of cookies in accordance with this policy.
      </p>
      <p className="mb-4">
        Cookies help us understand user behavior, personalize content, and enhance site performance.
      </p>
      <p className="mb-4">
        You may control or delete cookies through your browser settings.
      </p>
    </div>
  );
}
